import React from 'react'
import { ReactComponent as ConstructionIcon } from '../assets/images/Construction-icon.svg'

import { Auth } from 'aws-amplify'
import { StorageService } from '../lib/StorageService'

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 'auto',
        width: '100%',
        height: '100vh',
    },
    logout: {
        marginTop: '2em',
        cursor: 'pointer',
        color: '#1BAAF1',
    },
}

const goToLogin = () => {
    Auth.signOut()
        .then(() => window.location.reload())
        .catch((err) => console.log(err))

    StorageService.clearData()
}

const ErrorPage = () => {
    return (
        <div style={styles.container}>
            <ConstructionIcon style={{ height: 200, marginBottom: 30 }} />
            <h1>Ooops... Something went wrong.</h1>
            <span>Sorry for the inconvenience we are working on it. Please check back later.</span>
            <span style={styles.logout} onClick={goToLogin}>
                Back to Login Screen
            </span>
        </div>
    )
}

export default ErrorPage
